import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const SaleIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 30 30" fill="none" {...props}>
    <path
      d="M11.25 11.25H11.2625M18.75 18.75H18.7625M20 10L10 20M27.5 15C27.5 21.9036 21.9036 27.5 15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15ZM11.875 11.25C11.875 11.5952 11.5952 11.875 11.25 11.875C10.9048 11.875 10.625 11.5952 10.625 11.25C10.625 10.9048 10.9048 10.625 11.25 10.625C11.5952 10.625 11.875 10.9048 11.875 11.25ZM19.375 18.75C19.375 19.0952 19.0952 19.375 18.75 19.375C18.4048 19.375 18.125 19.0952 18.125 18.75C18.125 18.4048 18.4048 18.125 18.75 18.125C19.0952 18.125 19.375 18.4048 19.375 18.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
